import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { comma } from "@/utils";
import { orderTypeOptions, orderSubStatusOption } from "@/constants/selectOptions";
import { useGetAssignedOrderListMutation } from "@/redux/orderApi";

export const OrderListPopup = ({ layer = true, onClose, setFormData, onOrderSelect }) => {
    const [query, setQuery] = useState("");
    const [selectedOrder, setSelectedOrder] = useState(null);

    const [getAssignedOrderList, { data: assignedData, isLoading: assignedIsLoading, error: assignedError, refetch: assignedRefetch }] =
        useGetAssignedOrderListMutation();

    useEffect(() => {
        getAssignedOrderList({});
    }, []);

    const handleSearch = () => {
        assignedRefetch();
    };

    const handleSelectOrder = (vehicle) => {
        setSelectedOrder(vehicle);
    };

    const handleConfirm = () => {
        if (!selectedOrder) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "오더를 선택하세요.",
            }));
            return;
        }
        onOrderSelect(selectedOrder);
        onClose();
    };

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>
            <div className="popup vehicle-list-popup">
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">오더 선택</span>
                    </div>
                    <div className="btn-close" onClick={onClose}></div>
                </div>
                <div className="popup-content">
                    <div className="table-container">
                        <div className="table-filter">
                            <div className="filter-row">
                                <div className="filter-item">
                                    <div className="item-content">
                                        <div className="item-input">
                                            <input
                                                type="text"
                                                placeholder="제목 입력"
                                                value={query || ""}
                                                onChange={(e) => setQuery(e.target.value)}
                                            />
                                        </div>
                                        <div className="item-buttons">
                                            <button type="button" className="btn-search" onClick={handleSearch}>
                                                검색
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 차량 리스트 */}
                        <div className="table-content">
                            <div className="table-wrapper">
                                <div className="table">
                                    <table>
                                        <colgroup>
                                            <col width={"8%"} />
                                            <col width={"12%"} />
                                            <col width={"12%"} />
                                            <col width={"12%"} />
                                            <col width={"44%"} />
                                            <col width={"12%"} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">선택</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">오더번호</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">구분</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">차량번호</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">차량정보</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">상태</div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {assignedData && assignedData.data && assignedData.data.length > 0 ? (
                                                assignedData.data.map((item) => (
                                                    <tr key={item.id}>
                                                        <td>
                                                            <div className="cell" style={{ height: "100%" }}>
                                                                <div className="input-checkbox">
                                                                    <div className="checkbox" style={{ display: "flex" }}>
                                                                        <input
                                                                            type="radio"
                                                                            name="selectedOrder"
                                                                            id={`selectedOrder-${item.id}`}
                                                                            checked={selectedOrder?.id === item.id}
                                                                            onChange={() => handleSelectOrder(item)}
                                                                        />
                                                                        <label htmlFor={`selectedOrder-${item.id}`}></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.serialNumber}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">
                                                                    <span className="cell-tag tag-box tag-green">
                                                                        {orderTypeOptions.find((e) => e.value === item.orderType)?.label}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.carNumber}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{`${item.modelName ?? ""} ${
                                                                    item.modelDetailName ?? ""
                                                                } ${item.className ?? ""} ${item.trimName ?? ""} (${comma(
                                                                    item.displacement ?? 0
                                                                )}cc)`}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                {(() => {
                                                                    const status = orderSubStatusOption.find(
                                                                        (e) => e.value === item?.orderSubStatus
                                                                    );
                                                                    return (
                                                                        <span className={`cell-tag ${status?.txtColor || ""}`}>
                                                                            {status?.label}
                                                                        </span>
                                                                    );
                                                                })()}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="data-empty">
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">오더 데이터가 없습니다.</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button type="button" className="btn btn-primary btn-cancel" onClick={onClose}>
                        취소
                    </button>
                    <button type="button" className="btn btn-primary btn-confirm" onClick={handleConfirm}>
                        완료
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};
